<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-07-07 10:14:29
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-13 14:56:33
-->
<template>
	<div class="yx-form-wrap">
		<el-form :inline="true" :model="formData" label-width="96px">
			<el-form-item label="素材标题">
				<el-input v-model="formData['title']" placeholder="请输入素材标题"></el-input>
			</el-form-item>
			<el-form-item label="素材ID">
				<el-input v-model="formData['id']" placeholder="请输入素材ID"></el-input>
			</el-form-item>
			<el-form-item label="素材标签">
				<SelectTag v-model="formData['tagIds']" multiple collapse-tags class="flex-1" type="2" placeholder="请选择素材标签"></SelectTag>
			</el-form-item>
			<el-form-item label="商品ID">
				<el-input v-model="formData['thirdProductId']" placeholder="请输入商品ID"></el-input>
			</el-form-item>
			<el-form-item label="创建时间">
				<el-date-picker
					class="dataPicker"
					v-model="formData.add_start"
					type="daterange"
					@change="value => createdSetTime(value)"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:default-time="['00:00:00', '23:59:59']"
				></el-date-picker>
			</el-form-item>
			<el-form-item label=" ">
				<el-button type="primary" @click="onSubmit">搜索</el-button>
				<el-button @click="onClear">清空</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
import SelectTag from '@/components/business/tagDialog/selectTagNew.vue';

export default {
	data() {
		return {
			formData: {
				title: '',
				tagIds: [],
				thirdProductId: '',
				add_start: '',
				addTimeStart: '',
				addTimeEnd: '',
			},
		};
	},
	mounted() {
		utils.initQueryParams(this.formData, this.$route.query, {
			matches: [
				{ key: 'thirdProductId', queryKey: 'thirdProductId', defaultValue: '' },
				{ key: 'tagIds', queryKey: 'tagIds', format: val => (val ? val.split(',') : []) },
			],
		});
	},
	methods: {
		createdSetTime(value) {
			const [start, end] = value || [];
			this.formData.addTimeStart = start ? start.getTime() / 1000 : '';
			this.formData.addTimeEnd = end ? end.getTime() / 1000 : '';
		},
		onSubmit: throttle(function () {
			const { add_start, ...rest } = this.formData;
			this.$emit('onSubmit', rest);
		}, 1000),
		onClear() {
			this.formData = this.$options.data().formData;
			this.onSubmit();
		},
	},
	components: {
		SelectTag,
	},
};
</script>

<style lang="less" scoped>
.dataPicker /deep/ .el-range-input::placeholder {
	font-size: 14px;
}
</style>
